export default class ItemMetrics {
  calcActualBorderThickness(borderThickness, ratioWidth) {
    if (borderThickness == undefined) {
      borderThickness = 0;
    }
    return 0.01 * borderThickness * ratioWidth;
  }
}
